module.exports = __webpack_public_path__ + "img/calendar.3cf67919.svg";